window.addEventListener("DOMContentLoaded", () => {
    const labels = document.querySelectorAll('.product-form__input label')
    const prodId = document.querySelector(".product-form form input[name='id']").dataset.productid
    labels.forEach(label => {
        label.addEventListener('click', () => {
            const widget = document.querySelector('.rc-container-wrapper')
            if (widget) return;
            if (document.querySelector(".product-form form input[name='id']").dataset.productid === undefined) return;
            const config = {
                productId: parseInt(prodId),
                injectionParent: 'form[action*="cart/add"]', // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected
            };
            window.ReChargeWidget.createWidget(config);
        })
    })
});
